// extracted by mini-css-extract-plugin
export var contentContainer = "OpenRoles-module--contentContainer--6Og++";
export var ctaContainer = "OpenRoles-module--ctaContainer---+ANw";
export var description = "OpenRoles-module--description--r8e4Q";
export var openRolesWrapper = "OpenRoles-module--openRolesWrapper--3mE8o";
export var title = "OpenRoles-module--title--EAFoV";